var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.684,
    cy: 24.684,
    r: 24.684,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1943 30.6494H20.9824V28.181H14.1943V30.6494ZM14.1943 25.7126H22.2166V23.2442H14.1943V25.7126ZM14.1943 20.7757H22.2166V18.3073H14.1943V20.7757ZM27.5654 30.6493H35.5877V28.1809H27.5654V30.6493ZM27.5654 25.7127H34.3535V23.2443H27.5654V25.7127ZM27.5654 20.7758H35.5877V18.3074H27.5654V20.7758ZM29.8284 13.3706C26.1242 13.3706 24.8888 15.5305 24.8888 15.5305C24.8888 15.5305 23.6534 13.3706 19.9548 13.3706C16.2563 13.3706 11.3154 13.3932 11.3154 13.3932V35.5867C11.3154 35.5867 17.4856 35.5873 19.9548 35.5867C22.4241 35.5862 23.6574 38.0546 23.6574 38.0546H26.1287C26.1287 38.0546 27.36 35.5867 29.8284 35.5867C32.2968 35.5867 38.4678 35.5867 38.4678 35.5867V13.3932C38.4678 13.3932 33.5327 13.3706 29.8284 13.3706Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookCircle);
export default __webpack_public_path__ + "static/media/BookCircle.c1a3e0735a13cc40159f81705e340a96.svg";
export { ForwardRef as ReactComponent };